export default __webpack_public_path__ + "83c12c7cb6c88ebaa7ea98a94e54e705.png";